<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i class="fa fa-times" (click)="cancel()" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
}
  @if (!loading) {

    <ul class="nav nav-pills">
      <li [class.active]="step === 'update'"><a (click)="changeStep('update')" style="cursor: pointer;">Update Address For All</a></li>
      <li [class.active]="step === 'change'"><a (click)="changeStep('change')" style="cursor: pointer;">Change This Entities Address</a></li>
      <li [class.active]="step === 'new'"><a (click)="changeStep('new')" style="cursor: pointer;">Create New Address</a></li>
    </ul>

    <!-- Update / New form -->
    @if (step === 'update' || step === 'new') {
<div class="gold-form">
      <form>
        @if (step === 'update') {
<div class="form-group">
          <label>Address ID:</label>
          <input class="form-control" type="text" [ngModel]="address.address_id" name="address_id" disabled>
        </div>
}
        <div class="form-group">
          <label class="required">Country:</label>
          <select class="form-control" [(ngModel)]="address.address_country" name="country" required>
            <option [ngValue]="null" disabled>Select</option>
            @for (c of countries; track $index) {
<option [ngValue]="c.code">{{ c.name }}</option>
}
          </select>
        </div>
        <div class="form-group">
          <label class="required">Address Line 1:</label>
          <input class="form-control" type="text" [(ngModel)]="address.address_line1" name="address1" (ngModelChange)="updateAddress()">
        </div>
        <div class="form-group">
          <label>Address Line 2:</label>
          <input class="form-control" type="text" [(ngModel)]="address.address_line2" name="address2" (ngModelChange)="updateAddress()">
        </div>
        <div class="form-group">
          <label class="required">Address City:</label>
          <input class="form-control" type="text" [(ngModel)]="address.address_city" name="city" (ngModelChange)="updateAddress()">
        </div>
        @if (address.address_country === 'US') {
<div class="form-group">
          <label class="required">Address State:</label>
          <select class="form-control" [(ngModel)]="address.address_us_state" name="state">
            <option [ngValue]="null" disabled>Select</option>
            @for (s of states; track $index) {
<option [ngValue]="s.code">{{ s.name }}</option>
}
          </select>
        </div>
}
        @if (address.address_country !== 'US') {
<div class="form-group">
          <label>Address Province:</label>
          <input class="form-control" type="text" [(ngModel)]="address.address_province">
        </div>
}
        <div class="form-group">
          <label class="required">Address Postal Code:</label>
          <input class="form-control" type="text" [(ngModel)]="address.address_postal_code" name="postal_code" required>
        </div>
        <div class="form-group">
          <label>Address Start Date:</label>
          <input class="form-control" type="date" [(ngModel)]="address.address_start_date" name="start_date">
        </div>
        <div class="form-group">
          <label>Address End Date:</label>
          <input class="form-control" type="date" [(ngModel)]="address.address_end_date" name="end_date">
        </div>
        <div class="form-group">
          <input type="checkbox" [(ngModel)]="irsAddress" (ngModelChange)="setIrsAddress()" name="irsSame">
          <label>IRS Address is the Same as Main Address</label>
        </div>
        <div class="form-group">
          <label>IRS Address Line 1:</label>
          <input class="form-control" type="text" [(ngModel)]="address.irs_address_line1" [disabled]="irsAddress">
        </div>
        <div class="form-group">
          <label>IRS Address Line 2:</label>
          <input class="form-control" type="text" [(ngModel)]="address.irs_address_line2" [disabled]="irsAddress">
        </div>
        <div class="form-group">
          <label>IRS Address City:</label>
          <input class="form-control" type="text" [(ngModel)]="address.irs_address_city" [disabled]="irsAddress">
        </div>
        <!-- New address: entity link -->
        @if (step === 'new') {
<div class="form-group">
          @if (!entityTypeLookUpSelected && !entityTypeBlankSelected) {
<div>
            <label>New Address will be linked to</label>
            <br><label>{{ legalEntityString }}</label>
          </div>
}
          <div class="form-group">
            <input type="checkbox" [(ngModel)]="entityTypeCurrentSelected" (ngModelChange)="setCurrentEntityLinkType()">
            <label>Link to Currently Selected Address</label>
            <br><label>{{ legalEntityString }}</label>
          </div>
          <div class="form-group">
            <input type="checkbox" [(ngModel)]="entityTypeLookUpSelected" (ngModelChange)="setLookupEntityLinkType()">
            <label>Link to different Entity</label>
            <input class="form-control" type="text" [(ngModel)]="entitySearchText" [disabled]="entityLinkDisabled" placeholder="Type to search entity">
            <button type="button" class="btn btn-sm" (click)="searchEntity()" [disabled]="entityLinkDisabled || !entitySearchText">Search</button>
            @if (entitySearchResults.length) {
<ul class="search-results">
              @for (e of entitySearchResults; track $index) {
<li (click)="setEntity(e)" style="cursor: pointer;">{{ e.entity_string }}</li>
}
            </ul>
}
          </div>
          <div class="form-group">
            <input type="checkbox" [(ngModel)]="entityTypeBlankSelected" (ngModelChange)="setBlankEntityLinkType()">
            <label>Do Not Link to any Entity</label>
          </div>
        </div>
}
      </form>
    </div>
}

    <!-- Change: search and select address -->
    @if (step === 'change') {
<div class="gold-change">
      <div class="form-group">
        <label>Search Address</label>
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="addressSearchText" [disabled]="addressSet" placeholder="Type and click Search">
          <button type="button" class="btn btn-sm" (click)="searchAddress()" [disabled]="addressSet || !addressSearchText">Search</button>
        </div>
        @if (addressSearching) {
<div class="searching"><i class="fa fa-spinner fa-spin"></i> Searching...</div>
}
        @if (addressSearchResults.length && !addressSet) {
<ul class="search-results">
          @for (a of addressSearchResults; track $index) {
<li (click)="setAddress(a)" style="cursor: pointer;">{{ a.address_string || (a.address_line1 + ', ' + a.address_city) }}</li>
}
        </ul>
}
        @if (addressSet) {
<button type="button" class="btn btn-sm" (click)="clearAddressSelection()">Clear selection</button>
}
      </div>
      @if (addressSet && selectedAddress) {
<div class="row">
        <div class="col">
          <label>Selected Address</label>
          <p>{{ selectedAddress.address_line1 }}<br>{{ selectedAddress.address_line2 }}<br>{{ selectedAddress.address_city }}<br>{{ selectedAddress.address_postal_code }}</p>
        </div>
      </div>
}
    </div>
}
  
}
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading || loading" (click)="save(step)">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save Address
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
